<div class="p-md-5 p-3 header-container lh-sm d-flex flex-column justify-content-between">
  <div class="d-flex justify-content-between position-fixed overflow-hidden header-top">
    <div class="menu-item" (click)="toggleMenu()">
      <p class="mb-0">MENU</p>
      <p class="mb-0" style="border-bottom: solid white 1px;">MENU</p>
    </div>
    
    <div class="menu-item" (click)="scrollToFooter()">
      <p class="me-md-5 me-3 mb-0">CONTACT</p>
      <p class="me-md-5 me-3 mb-0" style="border-bottom: solid white 1px;">CONTACT</p>
    </div>
    
  </div>

  <div></div>

  <div class="d-flex justify-content-around gap-5 flex-column flex-md-row">
    <div class="logo-container position-relative align-self-center">
      <img src="/assets/img/mac-logo-white.svg" alt="MAC-76B25 Logo">
      <img src="/assets/img/mac-logo-green.svg" class="logo2 position-absolute" style="left: 0;">
    </div>
    <div class="text-end align-self-center mt-md-0 mt-3">
      <p class="mb-0">MAC 76B25 ___ The bridge between<br>
        <span style="position: relative; left: 35px;">Art and Technology</span>
      </p>
    </div>
  </div>

  <div class="header-end d-flex justify-content-between">
    <div class="d-flex gap-sm-5 gap-0">
      <p>
        A vision of<br>
        <span style="position: relative; left: 35px;">Bitveil <img src="/assets/img/bitveil-logo.svg"
            alt="Bitveil Logo">
          and<br>Modular Labs <img src="/assets/img/modular-labs-logo.svg" alt="Modular Labs Logo"></span>
      </p>

      <p>
        <img src="/assets/img/fermion-logo.svg" id="fermion-logo" alt="Fermion Logo" style="margin-bottom: 5px;"><br>
        Fermion
      </p>
    </div>


    <div class=""></div>

    <p style="margin-right: 30px;" class="d-none d-md-inline">
      Via<br>
      <span style="position: relative; left: 30px;">Mecenate<br> 76B/25</span>
    </p>
  </div>
</div>